import { FC, useEffect, useMemo } from 'react';
import { ExaminationPageSectionId } from '../models';
import { FormattedMessage, useIntl } from 'react-intl';
import { AuscultationGroup } from '@higo/common/src/components';
import styled from 'styled-components';
import { ExaminationPageSection } from './ExaminationPageSection';
import {
  useAbdominalAuscultationPhysicalExaminationQuery,
  useAbdominalAuscultationPhysicalExaminationResourceFiles,
} from '@higo/common/src/features/ExaminationPage/hooks/queries';
import { AuscultationPointListItem } from '@higo/common/src/components/Auscultation/AuscultationPointListItem';
import { media } from '@higo/ui';

const AuscultationGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 0;
  margin: 0;
  margin-left: 35px;
  ${media.mobile.max} {
    gap: 0.5rem;
  }
`;

export interface LiveVisitAbdominalAuscultationSectionProps {
  isStatusCanceledByUser?: boolean;
  point: any;
}

export const LiveVisitAbdominalAuscultationSection: FC<LiveVisitAbdominalAuscultationSectionProps> =
  ({ isStatusCanceledByUser, point }) => {
    const { data, refetch } = useAbdominalAuscultationPhysicalExaminationQuery(
      point.examId,
    );

    const specificPointData = data?.abdominalAuscultationResults.filter(
      (item) => item.pointer?.toString() === point.auscultationPointIndex,
    );
    const intl = useIntl();

    const specificPointFileId =
      specificPointData && specificPointData[0] && specificPointData[0].fileId;

    const { data: fileResourceMap } =
      useAbdominalAuscultationPhysicalExaminationResourceFiles(point.examId);

    let specificPointFileResourceMap;

    for (let key in fileResourceMap) {
      if (
        specificPointFileId &&
        fileResourceMap[key].fileId &&
        fileResourceMap[key].fileId === specificPointFileId
      ) {
        specificPointFileResourceMap = fileResourceMap[key];
        break;
      }
    }

    const label = `${intl.formatMessage({
      id: 'common.point',
    })} ${point.auscultationPointIndex}`;

    const tagline = intl.formatMessage({
      id: point.auscultationPointIndex % 2 ? 'common.right' : 'common.left',
    });

    useEffect(() => {
      refetch();
    }, [point]);

    return (
      <AuscultationGroupContainer>
        {/* <ExaminationPageSection
        title={
          <FormattedMessage id="examinationPage.section.abdominalAuscultation.title" />
        }
        sectionId={ExaminationPageSectionId.Abdominal}
        isVisitSection={true}
      > */}
        {fileResourceMap && specificPointFileId && (
          <AuscultationPointListItem
            id={point.auscultationPointIndex}
            key={point.auscultationPointIndex}
            label={label}
            file={specificPointFileResourceMap}
          />
        )}
        {/* </ExaminationPageSection> */}
      </AuscultationGroupContainer>
    );
  };
